'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTypicalResponseTime = exports.getTeamMembersAvailabilityStrategy = exports.getOutsideOfficeHoursStrategy = exports.getOutsideOfficeHoursMessage = exports.getOfficeHours = exports.getAwayMessage = exports.getAwayInOfficeHoursStrategy = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _keyPaths = require('../../constants/keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAwayInOfficeHoursStrategy = exports.getAwayInOfficeHoursStrategy = (0, _getIn2.default)(_keyPaths.AWAY_IN_OFFCE_HOURS_STRATEGY);
var getAwayMessage = exports.getAwayMessage = function getAwayMessage(config) {
  return (0, _getIn2.default)(_keyPaths.AWAY_MESSAGE, config) || '';
};
var getOfficeHours = exports.getOfficeHours = (0, _getIn2.default)(_keyPaths.OFFICE_HOURS);
var getOutsideOfficeHoursMessage = exports.getOutsideOfficeHoursMessage = function getOutsideOfficeHoursMessage(config) {
  return (0, _getIn2.default)(_keyPaths.OUTSIDE_OFFICE_HOURS_MESSAGE, config) || '';
};
var getOutsideOfficeHoursStrategy = exports.getOutsideOfficeHoursStrategy = (0, _getIn2.default)(_keyPaths.OUTSIDE_OFFICE_HOURS_STRATEGY);
var getTeamMembersAvailabilityStrategy = exports.getTeamMembersAvailabilityStrategy = (0, _getIn2.default)(_keyPaths.TEAM_MEMBERS_AVAILABILITY_STRATEGY);
var getTypicalResponseTime = exports.getTypicalResponseTime = (0, _getIn2.default)(_keyPaths.TYPICAL_RESPONSE_TIME);